// extracted by mini-css-extract-plugin
export default {"welcome":"styles_welcome__07iKF","mainContainer":"styles_mainContainer__OaKN1","infoContainer":"styles_infoContainer__4wtxG","buttonsContainer":"styles_buttonsContainer__suIC2"};